export default __webpack_public_path__ + "static/media/logo-light.dd4cdfd3.png";